import { Entry, EntryFields } from "contentful";

export interface HtmlModel {
    value: EntryFields.RichText;
}

export interface HtmlNode {
    data: any;
    nodeType: NodeType
}

export interface HtmlContainerNode extends HtmlNode {
    content: HtmlNode[]
}

export interface DocumentNode extends HtmlContainerNode {

}

export interface HtmlDataNode<T> extends HtmlNode {
    data: T
}

export interface TextNode extends HtmlNode {
    marks: [];
    value: string;
}

export interface ParagraphNode extends HtmlContainerNode {

}

export interface HyperlinkNode extends HtmlContainerNode {
    data: {
        uri: string
    }
}

export interface EmbeddedAssetBlockNode extends HtmlContainerNode {
    data: Entry<any>
}

export enum NodeType {
    Document = 'document',
    Paragraph = 'paragraph',
    EmbeddedAssetBlock = 'embedded-asset-block',
    Text = 'text',
    Hyperlink = 'hyperlink',
    EntryHyperlink = 'entry-hyperlink',
    AssetHyperlink = 'asset-hyperlink',
    UnorderedList = 'unordered-list',
    OrderedList = 'ordered-list',
    Heading1 = 'heading-1',
    Heading2 = 'heading-2',
    Heading3 = 'heading-3',
    Heading4 = 'heading-4',
    Heading5 = 'heading-5',
    Heading6 = 'heading-6',
    ListItem = 'list-item',
    Blockquote = 'blockquote',
    Hr = 'hr',
    EmbeddedEntryBlock = 'embedded-entry-block'
}